import React from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';

const regex = /<([^<>]*)>/g; // looking for `<something>` occurrences

export default class MarkushValue extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  transformValue(value) {
    return value.split(regex).map((part, index) => (index % 2 === 1 ? <a onClick={() => this.scrollTo(part)}>{part}</a> : part));
  }

  scrollTo(element) {
    const { uid } = this.props;
    const escaped = element.replace(/['"$^]/g, (match) => `\\${match === '"' ? '&quot;' : match}`);
    scrollIntoView(`#${uid}-${escaped}`, { behavior: 'smooth', align: { top: -25 }, time: 300 });
  }

  render() {
    const { value = '' } = this.props;

    return value && <>{this.transformValue(value)}</>;
  }
}

MarkushValue.propTypes = {
  value: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
};
